import _ from 'lodash';

import { PendingChangesActionType } from 'constants/pendingChanges';

import { normalizeLoanChangesValue } from '../../../LoanChangesHistory/LoanChangesHistory.utils';

const pluralizeChanges = count => `${count} ${count === 1 ? 'change' : 'changes'}`;

const formatSummaryValue = value => {
  const normalized = normalizeLoanChangesValue(value);

  return _.isNil(normalized) || normalized === '' ? '—' : normalized;
};

export const getSaveSummaryIntro = ({ isOwnChangesScope, savedCount, feeChangesCount = 0 }) => {
  const countText = savedCount ? pluralizeChanges(savedCount) : 'changes';
  const feeText = feeChangesCount
    ? ` and the ${feeChangesCount} fee ${feeChangesCount === 1 ? 'change' : 'changes'} ${savedCount === 1 ? 'it' : 'they'} caused`
    : '';
  const verb = savedCount === 1 && !feeChangesCount ? 'is' : 'are';

  return isOwnChangesScope
    ? `Only your ${countText}${feeText} ${verb} saved. Other people's pending changes are not affected.`
    : `Only the selected users' ${countText}${feeText} ${verb} saved. Other pending changes are not affected.`;
};

export const getAutomaticFeeChangeLine = ({
  feeName,
  pendingChangesActionType,
  oldValue,
  newValue,
}) => {
  if (pendingChangesActionType === PendingChangesActionType.ADDED) {
    return `Fees: ${feeName} ${formatSummaryValue(newValue)}`;
  }

  if (pendingChangesActionType === PendingChangesActionType.DELETED) {
    return `Fees: ${feeName} ${formatSummaryValue(oldValue)} → removed`;
  }

  return `Fees: ${feeName} ${formatSummaryValue(oldValue)} → ${formatSummaryValue(newValue)}`;
};

export const getWillBeSavedLine = ({ propertyName, oldValue, newValue }) =>
  `${propertyName}: ${formatSummaryValue(oldValue)} → ${formatSummaryValue(newValue)}`;

export const getAlsoChangedLine = ({ otherChanges, isOwnChangesScope }) => {
  const others = otherChanges
    .map(({ authorName, newValue }) => `${authorName} has ${formatSummaryValue(newValue)}`)
    .join(', ');
  const savedSubject = isOwnChangesScope ? 'Yours' : 'The selected change';

  return `${others} pending. ${savedSubject} is saved, and theirs stays pending.`;
};

export const getRecalculatedToggleText = count =>
  `${count} recalculated ${count === 1 ? 'value' : 'values'} saved with them`;

export const getStaysPendingLine = ({ label, changesCount }) =>
  `${label}: ${pluralizeChanges(changesCount)}`;
